import { useContext, useEffect, useState } from "react";
import { Card, Spin } from "antd";
import ActivityModal from "./ActivityModal/ActivityModal";
import "../Personal/employee.scss";
import "./NameCard.scss";
import { Row } from "antd";
import dayjsTZ from "../../../../utils/dayjs";
import driveApi from "../../../DriveRequest/driveApi";
import { useSelector } from "react-redux";
import { API } from "aws-amplify";
import { message } from "antd";
import {
  showLoadingMsg,
  showSuccessMsg,
} from "../../../Documentation/utils/Messages";
import EmployeeReasonModal from "./EmployeeReasonModal/EmployeeReasonModal";
import GoogleDriveUpload from "../../../Konfigurimet/Profile/GoogleDriveUpload";
import PunonjesitContext from "../../store/PunonjesitContext";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import { useAuth } from "../../../../authentication/authHelpers";
import { editEmployee } from "../../../../store/actions";
import { useDispatch } from "react-redux";

// * @EneaXharau - Added Websocket connection
// const socketHandler = new WebSocket(getSocketUrl("/dashboard/sockets"));

function NameCard() {
  const { employee, setEmployee } = useContext(PunonjesitContext);
  const auth = useAuth();
  const dispatch = useDispatch();

  const { users, isDarkMode } = useSelector((state) => state.usersList);
  const { accessToken } = useSelector((state) => state.accessToken);
  const driveRequest = driveApi({ accessToken });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentFile, setCurrentFile] = useState("");
  const [spinning, setSpinning] = useState(true);
  const [spin, setSpin] = useState(false);

  //#region CHANGE STATUS
  const changeEmployeeStatus = async ({ data }) => {
    setSpin(true);
    let changes = [];
    changes.push({
      activity: "Ndryshuar",
      author: auth?.user?.given_name + " " + auth?.user?.family_name,
      changeDate: dayjsTZ().valueOf(),
      field: "Statusi i punonjësit",
      oldValue: employee?.employeeStatus,
      newValue: data?.employeeStatus,
    });
    const toSend = {
      ...data,
      // employeeReasonforSuspension: reason || "Nuk ka arsye largimi!",
      // employeeReasonforTermination: reason || "Nuk ka arsye shkarkimi!",
      employeeDateOfReEmployment:
        data?.employeeStatus === "Aktiv" ? dayjsTZ().valueOf() : undefined,
      keylog: [...(employee?.keylog || []), ...changes],
    };
    await API.put("employees", `/employees/${employee.employeeId}`, {
      body: { ...toSend },
    }).then(async (res) => {
      /**
       * * @EneaXharau - Added socket emitter
       * * .send() takes -> { request: String, body: any} -> stringified
       */
      // if (socketHandler.readyState === socketHandler.OPEN) {
      //   socketHandler.send(
      //     JSON.stringify({
      //       request: "user_edit",
      //       body: res?.employee?.Item,
      //       id: auth?.employeeId,
      //     })
      //   );
      // }
      showLoadingMsg({ content: "Duke ruajtur..." });
      showSuccessMsg({ content: "Të dhënat u ruajtën!" });
      setEmployee(res?.employee?.Item);
      setSpin(false);
    });
  };

  function disableStatusButtons() {
    const options = ["Larguar", "Shkarkuar"];
    if (options.includes(employee?.employeeStatus)) {
      return true;
    }
  }

  //#region ON PICKER SUCCESS
  const onPickerSuccess = async (params) => {
    const fileId = params?.uploadedFiles?.[0]?.id || "";

    if (!!fileId && !!employee?.employeeId) {
      setSpinning(true);
      const toSend = {
        googleDriveFileId: fileId,
        keylog: [
          ...(employee?.keylog || []),
          {
            activity: "Ndryshuar",
            author: auth?.user?.given_name + " " + auth?.user?.family_name,
            changeDate: dayjsTZ().valueOf(),
            field: "Fotoja e profilit",
            oldValue: "",
            newValue: params?.uploadedFiles?.[0]?.name || "",
          },
        ],
      };
      let promises = [];
      if (!!employee?.googleDriveFileId) {
        promises.push(
          driveRequest.deleteDriveItem(employee?.googleDriveFileId)
        );
      }
      promises.push(
        API.put("employees", `/employees/${employee?.employeeId}`, {
          body: { ...toSend },
        }).then((res) => dispatch(editEmployee(res?.employee?.Item)))
      );
      await Promise.allSettled(promises)
        .then(() => {
          setEmployee((prev) => ({ ...prev, ...toSend }));
          message.success("U ndryshua me sukses!");
        })
        .catch((err) => {
          console.error(err);
          message.error("Ndodhi nje gabim!");
        });
    }
  };

  const getProfilePicture = async () => {
    await driveRequest
      .getImageSrc(employee?.googleDriveFileId)
      .then((image) => {
        setCurrentFile(image?.src);
        setSpinning(false);
      });
  };

  useEffect(() => {
    let timeout;
    if (!!employee?.googleDriveFileId) {
      getProfilePicture();
    } else {
      timeout = setTimeout(() => {
        setSpinning(false);
      }, 1000);
    }
    return () => clearTimeout(timeout);
  }, [employee?.googleDriveFileId]);

  //#region RETURN
  return (
    <div style={{ width: "100%" }}>
      <div style={{ width: "100%", height: "100%" }}>
        <Card
          className={`name-card ${isDarkMode ? "dark" : ""}`}
          style={{ width: "100%", justifyContent: "center", height: "470px" }}
          title={
            <span
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {employee?.employeeFirstName} {employee?.employeeLastName}
            </span>
          }
        >
          <Row style={{ gap: 5 }}>
            <div className="act">Aktiv që prej:</div>
            <div id="active">
              {dayjsTZ(employee?.employeeHireDate).format("DD/MM/YYYY")}
            </div>
            <div className="nameCard-buttons">
              <MondayButton
                className="mondayButtonGreen"
                onClick={() => setIsModalVisible(true)}
                data-testid="shiko-ndryshimet-btn"
              >
                Shiko ndryshimet
              </MondayButton>
              {employee?.employeeStatus === "Aktiv" ? (
                <MondayButton
                  className="mondayButtonYellow"
                  data-testid="largo-btn"
                  onClick={() => {
                    setModalVisible("largo");
                  }}
                  disabled={
                    employee?.employeeStatus === "Larguar" ? true : false
                  }
                >
                  Largo
                </MondayButton>
              ) : (
                <MondayButton
                  onClick={() =>
                    changeEmployeeStatus({ data: { employeeStatus: "Aktiv" } })
                  }
                  data-testid="aktivizo-btn"
                  className={
                    employee?.employeeStatus === "Shkarkuar"
                      ? "disableActiveButton"
                      : "mondayButtonGreen"
                  }
                  spin={spin}
                  disabled={
                    employee?.employeeStatus === "Shkarkuar" ? true : false
                  }
                >
                  Aktivizo
                </MondayButton>
              )}
              {!!modalVisible ? (
                <EmployeeReasonModal
                  {...{
                    modalVisible,
                    setModalVisible,
                    employee,
                    changeEmployeeStatus,
                  }}
                />
              ) : null}
              <MondayButton
                className={
                  employee?.employeeStatus === "Shkarkuar"
                    ? "disableTerminateButton"
                    : "mondayButtonRed"
                }
                data-testid="shkarko-btn"
                onClick={() => {
                  setModalVisible("shkarko");
                }}
                disabled={disableStatusButtons()}
              >
                Shkarko
              </MondayButton>
            </div>
          </Row>

          {employee?.employeeStatus === "Larguar" ? (
            <div className="showReason">
              <span className="reasonLabel">Arsyeja e largimit:</span>
              <div className="reason">{employee?.employeeReasonforLeaving}</div>
            </div>
          ) : (
            ""
          )}
          {employee?.employeeStatus === "Shkarkuar" ? (
            <div className="showReason">
              <span className="reasonLabel">Arsyeja e shkarkimit:</span>
              <div className="reason">
                {employee?.employeeReasonforTermination}
              </div>
            </div>
          ) : (
            ""
          )}
          <div
            className="image-empView-div"
            style={spinning ? { height: 200, alignContent: "center" } : {}}
          >
            <Spin spinning={spinning}>
              {!!currentFile && (
                <img
                  className="empView-img"
                  data-testid="pfp-section"
                  src={currentFile}
                  alt="Flex"
                />
              )}
              {!spinning && !currentFile && (
                <div
                  data-testid="pfp-section"
                  style={{ height: 200, alignContent: "center" }}
                >
                  No photo uploaded
                </div>
              )}
            </Spin>
          </div>
          {users?.userRole === "Admin" &&
          employee?.employeeStatus === "Aktiv" ? (
            <GoogleDriveUpload
              emplyeesObj={employee}
              accessToken={accessToken}
              onPickerSuccess={onPickerSuccess}
              setCurrentFile={setCurrentFile}
              adminUpload={true}
              uploadImages={true}
              data-testid="google-upload-btn"
            />
          ) : null}
        </Card>
      </div>
      {!!isModalVisible ? (
        <ActivityModal
          setIsModalVisible={setIsModalVisible}
          keylog={employee?.keylog}
        />
      ) : null}
    </div>
  );
}
export default NameCard;
